module.exports = __webpack_public_path__ + "static/assets/4b6ca5259f1271d510f081867e746847.png";